import React from 'react'
import { Ticket } from '@core/Areas/AccountActivity/types'
import { DetailsSecondaryInfoStyled } from '@core/Areas/AccountActivity/Components/Ticket/Components/Details/Details.styles'
import { TicketDisplayContext } from '@core/Areas/AccountActivity/context'

export const SingleSingle: React.FC<{
  leg: Ticket['legs'][0]
}> = ({ leg }) => {
  const { sportName, eventNameLine2 } = leg

  const ticketDisplayContext = React.useContext(TicketDisplayContext)
  const isFuturesShare = leg.eventType === 'Feature Races' && ticketDisplayContext.type === 'share'

  if ((!sportName && !eventNameLine2) || isFuturesShare) return null

  return (
    <DetailsSecondaryInfoStyled data-testid='single-details-selection-info'>
      <dl>
        {eventNameLine2 && (
          <div data-tid-start-time>
            <dt>Comp:</dt>
            <dd>{eventNameLine2}</dd>
          </div>
        )}
        {sportName && (
          <div data-tid-start-time>
            <dt>Sport:</dt>
            <dd>{sportName}</dd>
          </div>
        )}
      </dl>
    </DetailsSecondaryInfoStyled>
  )
}
